module.exports = __webpack_public_path__ + "static/one-req-many-res-4-1-55a1959ee18cb1c3077ac94381cbd5fb.png";